import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import first from "../../img/1st.jpg";
import second from "../../img/2nd.jpg";
import third from "../../img/3rd.jpg";
import one from "../../img/530.jpg";
import "../pages/homestyle.css";
import l1 from "../../img/114235.png";
import l2 from "../../img/community.png";
import l3 from "../../img/SvgaLearn.png";
import l4 from "../../img/teacher-img.png";
import two from "../../img/750.jpg";
const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    //eslint-disable-next-line
  }, []);
  return (
    <Fragment>
      <div
        id='carouselExampleCaptions'
        className='carousel slide carousel-fade my-4 '
        data-ride='carousel'
      >
        <ol className='carousel-indicators'>
          <li
            data-target='#carouselExampleCaptions'
            data-slide-to='0'
            className='active'
          ></li>
          <li data-target='#carouselExampleCaptions' data-slide-to='1'></li>
          <li data-target='#carouselExampleCaptions' data-slide-to='2'></li>
        </ol>
        <div className='carousel-inner'>
          <div className='carousel-item active'>
            <img src={first} className='d-block w-100 h-75' alt='...' />
          </div>
          <div className='carousel-item'>
            <img src={second} className='d-block w-100' alt='...' />
          </div>
          <div className='carousel-item'>
            <img src={third} className='d-block w-100' alt='...' />
          </div>
        </div>
        <a
          className='carousel-control-prev'
          href='#carouselExampleCaptions'
          role='button'
          data-slide='prev'
        >
          <span
            className='carousel-control-prev-icon'
            aria-hidden='true'
          ></span>
          <span className='sr-only'>Previous</span>
        </a>
        <a
          className='carousel-control-next'
          href='#carouselExampleCaptions'
          role='button'
          data-slide='next'
        >
          <span
            className='carousel-control-next-icon'
            aria-hidden='true'
          ></span>
          <span className='sr-only'>Next</span>
        </a>
      </div>
      <div className='row jumbotron mx-auto'>
        <div className='col-6 col-md-3 text-center fontcool'>
          <img src={l1} className='mx-auto heignt-8-5-conditional' />
          <br />
          <br />
          <b>Get the resources easily available</b>
        </div>
        <div className='col-6 col-md-3 text-center fontcool'>
          <img src={l3} className='mx-auto heignt-8-5-conditional' />
          <br /> <br />
          <b>Improve your presentation skills</b>
        </div>
        <div className='col-6 col-md-3 text-center fontcool'>
          <img src={l2} className='mx-auto heignt-8-5-conditional' />
          <br /> <br />
          <b>Save your legacy and show it to the world</b>
        </div>
        <div className='col-6 col-md-3 text-center fontcool'>
          <img src={l4} className='mx-auto heignt-8-5-conditional' />
          <br /> <br />
          <b>Serve education and skills</b>
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-6 col-12 my-3'>
          <Link to='/youtube/videos/tpXs50jRzthiegHfi36D'>
            <div className='card border border-danger '>
              <img
                src='https://img.youtube.com/vi/OEz1SvwpV6o/0.jpg'
                className='card-img-top'
                alt='...'
              />
              <div className='card-body'>
                <h5 className='card-title titlefont'>How to make videos</h5>
                <p className='card-text fontcool'>
                  Video that teaches you how to make an efficient video
                  tutorial.
                </p>
              </div>
            </div>
          </Link>
        </div>
        <div className='col-sm-6 col-12 my-3'>
          <Link to='/youtube/videos/80XYdwG2I6yxcBMxe5Ph'>
            <div className='card border border-danger'>
              <img
                src='https://img.youtube.com/vi/LthZ8Yr1eUg/0.jpg'
                className='card-img-top'
                alt='...'
              />
              <div className='card-body'>
                <h5 className='card-title titlefont'>Introduction Video</h5>
                <p className='card-text fontcool'>
                  This Video describes usage and advantages of this platform
                </p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </Fragment>
  );
};

export default Home;
